export default __webpack_public_path__ + "static/media/diamondRubi.973e9346.svg";